import React, { useEffect, useRef } from 'react';

export function departmentAttention(departments) {
  return departments.map(department => {
    const reasons = [];
    if (department.manager_status !== 'OK') {
      reasons.push(department.manager_status === 'Primary Manager Not Set'
        ? 'More than one employee occupies the manager position. Select a primary manager.'
        : 'A department manager needs to be assigned.');
    }
    if (department.headcount_warning) reasons.push(department.headcount_warning);
    return { department, reasons };
  }).filter(item => item.reasons.length);
}

export default function DepartmentAttentionDialog({ items, onClose }) {
  const dialog = useRef(null);
  useEffect(() => { dialog.current.showModal(); }, []);
  return <dialog ref={dialog} onClose={onClose} aria-labelledby="department-attention-title"
    style={{ margin: 'auto', width: 'min(640px, calc(100vw - 32px))', maxHeight: '80vh', overflowY: 'auto', border: '1px solid #d7dfeb', borderRadius: 12, padding: 24, color: '#0f172a' }}>
    <h2 id="department-attention-title" style={{ marginBottom: 12 }}>Needs Attention</h2>
    {items.length ? <>
      <p>{items.length} organizational unit{items.length === 1 ? '' : 's'} need attention:</p>
      {items.map(({ department, reasons }) => <section key={department.id} style={{ padding: '16px 0', borderBottom: '1px solid #e2e8f0' }}>
        <h3>{department.name}{department.code ? ` (${department.code})` : ''}</h3>
        <ul style={{ paddingLeft: 22, marginTop: 8 }}>{reasons.map(reason => <li key={reason} style={{ marginTop: 6 }}>{reason}</li>)}</ul>
      </section>)}
    </> : <p>No organizational units currently need attention.</p>}
    <form method="dialog" style={{ marginTop: 20, textAlign: 'right' }}><button style={{ padding: '8px 18px', cursor: 'pointer' }}>Close</button></form>
  </dialog>;
}
